import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';

import CreateSource from './CreateSource';
import type { Source } from '../../types/deal';
import { apiGetById } from '../../services/genesisApi/httpsMethods';

const EditSourceWrapper = () => {
  const { sourceId } = useParams();
  const [source, setSource] = useState<Partial<Source>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSource = async () => {
      try {
        const response = await apiGetById('source', Number(sourceId));
        if (response && response.success && response.data) {
          setSource(response.data[0]);
        }
      } catch (error) {
        console.error('Failed to fetch source', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSource();
  }, [sourceId]);

  if (loading) {
    return (
      <Box sx={{ p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <CreateSource source={source} isEdit={true} />;
};

export default EditSourceWrapper;


